
import { useLanguage } from '@/hooks/useLanguage';
import { getAvailableLanguages, setLanguage, tx } from '@/utils/i18n';
import { Button } from "@/components/ui/button";
import { 
  DropdownMenu, 
  DropdownMenuContent, 
  DropdownMenuItem,
  DropdownMenuTrigger 
} from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";
import { LanguageFlag } from './LanguageFlag';

export function LanguageSelector({ compact = false }: { compact?: boolean }) {
  const currentLang = useLanguage();
  const languages = getAvailableLanguages();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant={compact ? "ghost" : "outline"} size={compact ? "icon" : "sm"} className={cn("gap-2", compact && "h-[42px] w-[42px] rounded-[10px] [&_svg]:h-4 [&_svg]:w-6")} aria-label={tx("Selecionar idioma")}>
          <LanguageFlag language={currentLang} />
          <span className={compact ? "sr-only" : "sr-only md:not-sr-only md:inline-block"}>
            {languages.find(l => l.code === currentLang)?.name}
          </span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        {languages.map(lang => (
          <DropdownMenuItem 
            key={lang.code}
            onClick={() => setLanguage(lang.code)}
            className={cn(
              "cursor-pointer gap-2",
              currentLang === lang.code && "bg-primary/10 text-primary"
            )}
          >
            <LanguageFlag language={lang.code} />
            {lang.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
